import React from "react";
import "../Css/OurExpertise.css";

import neet from "../assets/personalcoaching.webp";
import iit from "../assets/onlinetuto.webp";
import commerce from "../assets/groupcoaching.webp";
import target from "../assets/foundationcou.webp";

import medical from "../assets/medical.webp";
import engi from "../assets/engi.webp";
import board from "../assets/board.jpg";
import olympiads from "../assets/olympiads.webp";

const OurExpertise = () => {
  return (
    <section className="expertise">
      {/* HEADER */}
      <div className="expertise-header">
        <h2>Our Courses</h2>

        {/* decorative bubbles */}
        <span className="bubble bubble-1"></span>
        <span className="bubble bubble-2"></span>
      </div>

      {/* CONTENT */}
      <div className="expertise-container">

        <div className="expertise-item">
          <img src={neet} alt="NEET" />
          <h3>Personal Coaching</h3>
          <p>
            Go full personal with one on one coaching, monitoring and mentoring your way to success. Get all your doubts clear with maximum efficiency. Learn with your own pace. Save time. Learn Smart work
          </p>
          
          {/* <button
  className="enquiry-btn"
  onClick={() => window.open("https://wa.me/918849189845", "_blank")}
>
  Enquiry Now
</button> */}

        </div>

        <div className="expertise-item">
          <img src={iit} alt="IIT JEE" />
          <h3>Online Tutorials</h3>
          <p>Don't let the barriers of Distance and Cororna hinder you from realizing your potential. Get started Now online with personalized attention and Expert guidance.
          </p>
        </div>

        <div className="expertise-item">
          <img src={commerce} alt="Foundation 11th 12th" />
          <h3>Group Coaching</h3>
          <p>IITian's Chinmay Academy is the place where Learning is Truly fun. Fall in love with the subject, be it Physics , Maths , Chemistry or Biology. Learn the practical aspects and you shall Cherish the experience of learning.
          </p>
        </div>

        <div className="expertise-item">
          <img src={target} alt="6th to 10th" />
          <h3>Foundation Courses ( Upto Class 10)</h3>
          <p>
            Well begun is half done. Get your fundamentals clear early and move on to concept application. Get ahead of your schoolmates. Sharpen your weapons. Learn problem solving skills, Objective approach, Test taking strategies, and Calculate like lightning and thunder will follow.
          </p>
        </div>



        <div className="expertise-item">
          <img src={medical} alt="6th to 10th" />
          <h3>Medical Entrance</h3>
          <p>
            Students of classes XI and XII are prepared for NEET and other Medical Entrance Examinations. Emphasis is given on the basics and the level is increased at student's pace. Their problem solving skills and time management is continuously nurtured here.
          </p>
        </div>

        <div className="expertise-item">
          <img src={engi} alt="6th to 10th" />
          <h3>Engineering Entrance</h3>
          <p>
             Students of classes XI and XII are prepared for JEE, BITSAT and other Engineering Entrance Examinations. These exams demand a lot of skills like Conceptual clarity, Problem solving Skills, Exam strategies, Mind management etc. All these are honed at Chinmay.
          </p>
        </div>

        <div className="expertise-item">
          <img src={board} alt="6th to 10th" />
          <h3>Board Examinations</h3>
          <p>
            The pressure to perform in Boards whether it be CBSE ,GSEB, IC or IG is huge on a student. But with clear basics, right practice, paper writing skills and strategies anyone can score excellent marks. With personalized attention and feedback we develop these skills in our students.
          </p>
        </div>

        <div className="expertise-item">
          <img src={olympiads} alt="6th to 10th" />
          <h3>Olympiads</h3>
          <p>
            Preparing for the Olympiads not only gives you a great learning experience, it forces you to challenge your own abilities and overcome the barriers of your own mind. We at Chinmay teach you to do the same with proper guidance, motivation and learning tools.
          </p>
        </div>

      </div>

<button
  className="enquiry-btn"
  onClick={() => {
    window.location.href = "https://wa.me/918849189845";
  }}
>
  Enquiry Now
</button>

    </section>
  );
};

export default OurExpertise;
